<template>
    <div>
        <div class="d-flex flex-row justify-content-center align-items-center">
            <img
                :src="inactive.logo_url"
                :alt="inactive.name"
                class="align-middle mr-2 max-h-35px"/>
            <button
                class="d-inline btn btn-primary"
                @click="$refs.updateModal.openModal()"
            >
                {{ __('sale.add_provider.provider', {provider: inactive.name}) }}
            </button>
        </div>

        <update-account-modal ref="updateModal" :provider="inactive"/>
    </div>
</template>

<script>
import UpdateAccountModal from './UpdateAccountModal.vue'

export default {
    name: 'UpdateAccountDetails',

    components: {UpdateAccountModal},

    props: {
        inactive: Object,
    },
}
</script>